import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../../../revvComponents";

// Components Imports
import { Dropdown } from "../../../../../commonComponents";
import TableToGsheetConfirmationPopup from "../../../TableToGsheetConfirmationPopup";
import TableGsheetUnlinkPopup from "../../../TableGsheetUnlinkPopup";
import TableAPIUnlinkPopup from "../../../TableAPIUnlinkPopup";
import {
  preventEditorToDeactivate,
  coverpageThemeAction,
} from "../../../../../actions/DocumentActions/index";
import { tableAPILinkUnlink } from "../../../../../actions/TableFieldActions/index";

// Internal Imports
import { DOCUMENTS, COMMON } from "../../../../../constants";
import { GoogleSheetActions, QuotationActions } from "../../../../../actions";
import TableToQuoteConfirmationPopup from "../../../TableToQuoteConfirmationPopup";
import TableToQuoteUnlinkPopup from "../../../TableToQuoteUnlinkPopup";

import { UnlinkSectionTableWithExcel } from "../../../utils";
// Destructuring
const { TABLE_DATASOURCE_OPTIONS, DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { checkGSheetStoreForData } = GoogleSheetActions;
const { toggleTabAndToolPanelData } = QuotationActions;

const { TABLE_TYPE } = COMMON;

class DataSourceBtn extends Component {
  state = {
    showTabletoGsheetConfirmation: false,
    showTabletoQuoteConfirmation: false,
    showTableGsheetUnlink: false,
    showTabletoQuoteUnlink: false,
    showTableAPIUnlinkPopup: false,
  };

  componentDidMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _handleClick = e => {
    if (
      this.node &&
      !this.node.contains(e.target) &&
      this.props.showDataSourceDropdown
    ) {
      this.props.toggleDropdown(e, "DataSource");
      this.props.preventEditorToDeactivate(false);
    }

    if (
      this.node &&
      this.node.contains(e.target) &&
      this.props.showDataSourceDropdown
    ) {
      // prevent loosing editor focus when style/weight is selected
      this.props.preventEditorToDeactivate(true);
      e.preventDefault();
    }
  };

  // dataSourceDropDownRef = React.createRef();

  _moveToLinkedGoogleSheet = section => {
    checkGSheetStoreForData(section.id);
    if (this.props.isLocked) {
      this.props.toggleTabAndToolPanelData({
        tabView: section.data.attributes.label,
        isOpen: false,
        panelView: "",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    } else {
      this.props.toggleTabAndToolPanelData({
        tabView: section.data.attributes.label,
        isOpen: true,
        panelView: "google-catalog",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: section.id,
      });
    }
  };

  _moveToLinkedQuoteTable = () => {
    const QUOTE_TABLE = "QUOTE_TABLE";
    const DEAL_TABLE = "DEAL_TABLE";
    if (!this.props.isSharedDocument && !this.props.dealTableId) {
      if (this.props.quoteTableDetails) {
        this.props.toggleTabAndToolPanelData({
          tabView: QUOTE_TABLE,
          tabViewType: DEAL_TABLE,
          dealTableId: this.props.dealTableId,
          isOpen: false,
          panelView: null,
          page: DEAL_TABLE,
          showPriceBook: false,
        });
      } else {
        this.props.toggleTabAndToolPanelData({
          tabView: QUOTE_TABLE,
          tabViewType: DEAL_TABLE,
          dealTableId: this.props.dealTableId,
          isOpen: true,
          panelView: null,
          page: DEAL_TABLE,
          showPriceBook: true,
        });
      }
    }
  };

  _moveToLinkedExcelTable = section => {
    this.props.toggleTabAndToolPanelData({
      tabView: section.data.attributes.label,
      tabViewType: TABLE_TYPE.EXCEL_TABLE,
      isOpen: !this.props.isLocked,
      panelView: this.props.isLocked ? "" : "excel-catalog",
      page: TABLE_TYPE.EXCEL_TABLE,
      excelSheetId: this.props.section.id,
    });
  };

  _moveToLinkedExternalTableApi = () => {
    const linkedClauseField = this._tableApiField();
    const { linked_table_id: linkedTableId } = linkedClauseField.value;
    this.props.toggleTabAndToolPanelData({
      tabView: `${linkedClauseField.field_name} (smart table)`,
      tabViewType: TABLE_TYPE.EXTERNAL_API,
      isOpen: !this.props.isLocked,
      panelView: "",
      page: TABLE_TYPE.EXTERNAL_API,
      tableId: linkedTableId,
    });
  };

  _checkTableLinkedAndSynced = (linked, synced, syncedAttributes) => {
    if (linked && (synced || syncedAttributes)) {
      return true;
    }
    return false;
  };

  _checkTableLinkedAndSyncedWithGsheet = (linked, synced, type) => {
    if (linked && type === "GoogleSheet") {
      return true;
    }
    return false;
  };

  _checkTableLinkedAndSyncedWithQuote = (linked, synced, type) => {
    if (linked && type === "DealTable") {
      return true;
    }
    return false;
  };

  _checkTableLinkedAndSyncedWithExcel = (linked, synced, type) => {
    if (linked && type === "ExcelTable") {
      return true;
    }
    return false;
  };

  _actionMethod = dataSource => {
    if (dataSource === DOCUMENT_COMPONENT_TYPES.EXCEL_TABLE) {
      // this.props.updateComponentMeta({});
      // this.props.updateDocumentClickedComponentID(null, true, null);
      const updatedTableData = UnlinkSectionTableWithExcel(this.props.section);
      this.props.saveTable(updatedTableData);
    } else if (dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE) {
      this._updateMultipleState({ showTabletoQuoteUnlink: true });
    } else if (dataSource === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
      this._updateMultipleState({ showTableGsheetUnlink: true });
    } else if (dataSource === "TableApi") {
      this._updateMultipleState({ showTableAPIUnlinkPopup: true });
    }
  };

  _restoreTableAPI = tableAPIFieldId => {
    this.props
      .tableAPILinkUnlink(this.props.docId, tableAPIFieldId, "link")
      .then(() => {})
      .catch(err => {
        console.error("DataSourceBtn => _restoreTableAPI", err);
      });
  };

  _tableApiField = () => {
    const { clauseOptions } = this.props.section;
    const { fieldsUsed } = this.props;
    if (clauseOptions && clauseOptions.id) {
      const clauseField = fieldsUsed.find(
        field => field.id === clauseOptions.id,
      );
      if (clauseField && clauseField.type === "TABLE_API") {
        console.debug(clauseField);
        return clauseField;
      }
    }
    return null;
  };

  _dropdownOptionsData = () => {
    const options = [];
    const { connected } = this.props.section;
    const {
      data: {
        attributes: { dataSource, isUnlinkedTableAPI },
      },
    } = this.props.section;

    const tableApiField = this._tableApiField();
    TABLE_DATASOURCE_OPTIONS.forEach(option => {
      switch (option.id) {
        case "g-sheet": {
          if (tableApiField) break;
          options.push({
            ...option,
            optionIcon: this._checkTableLinkedAndSyncedWithGsheet(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? ["fas", "check-circle"]
              : null,
            optionIconColor: this._checkTableLinkedAndSyncedWithGsheet(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? "#37BC72"
              : null,
            optionIconClass: this._checkTableLinkedAndSyncedWithGsheet(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? "dropdown-option-icon-name"
              : null,
            action: () =>
              dataSource === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET
                ? this._moveToLinkedGoogleSheet(this.props.section)
                : this._updateMultipleState({
                    showTabletoGsheetConfirmation: true,
                  }),
          });
          break;
        }
        case "q-table": {
          if (tableApiField) break;
          options.push({
            ...option,
            optionIcon: this._checkTableLinkedAndSyncedWithQuote(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? ["fas", "check-circle"]
              : null,
            optionIconColor: this._checkTableLinkedAndSyncedWithQuote(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? "#37BC72"
              : null,
            optionIconClass: this._checkTableLinkedAndSyncedWithQuote(
              this.props.isLinkedToDataSource,
              connected,
              dataSource,
            )
              ? "dropdown-option-icon-name"
              : null,
            action: () =>
              dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE
                ? this._moveToLinkedQuoteTable(this.props.section)
                : this._updateMultipleState({
                    showTabletoQuoteConfirmation: true,
                  }),
          });
          break;
        }
        case "xls-upload": {
          if (tableApiField) break;
          options.push({
            ...option,
            optionIcon: this._checkTableLinkedAndSyncedWithExcel(
              this.props.isLinkedToDataSource,
              this.props.connected,
              dataSource,
            )
              ? ["fas", "check-circle"]
              : null,
            optionIconColor: this._checkTableLinkedAndSyncedWithExcel(
              this.props.isLinkedToDataSource,
              this.props.connected,
              dataSource,
            )
              ? "#37BC72"
              : null,
            optionIconClass: this._checkTableLinkedAndSyncedWithExcel(
              this.props.isLinkedToDataSource,
              this.props.connected,
              dataSource,
            )
              ? "dropdown-option-icon-name"
              : null,
            action: () =>
              dataSource === DOCUMENT_COMPONENT_TYPES.EXCEL_TABLE
                ? this._moveToLinkedExcelTable(this.props.section)
                : this.props.selectExcelFile(this.props.section),
          });
          break;
        }
        case "external-source-api": {
          const isLinkedWithTableAPI =
            this.props.isLinkedToDataSource &&
            dataSource === "TableApi" &&
            !isUnlinkedTableAPI;

          if (!tableApiField) break;
          options.push({
            ...option,
            name: (
              <>
                {option.name}
                {isUnlinkedTableAPI && (
                  <span className="datasourcebtn-restore-tableapi">
                    Restore
                  </span>
                )}
              </>
            ),
            optionIcon: isLinkedWithTableAPI ? ["fas", "check-circle"] : null,
            optionIconColor: isLinkedWithTableAPI ? "#37BC72" : null,
            optionIconClass: isLinkedWithTableAPI
              ? "dropdown-option-icon-name"
              : null,
            action:
              dataSource === "TableApi" && isUnlinkedTableAPI
                ? () => this._restoreTableAPI(tableApiField.id)
                : () => {
                    // #navigate to External API tab
                    this._moveToLinkedExternalTableApi(this.props.section);
                  },
          });
          break;
        }
        case "unlink-table": {
          if (
            (!this.props.isLinkedToDataSource && !tableApiField) ||
            (tableApiField && isUnlinkedTableAPI)
          )
            break;
          options.push({
            ...option,
            action: () => this._actionMethod(dataSource),
          });
          break;
        }
        default:
      }
    });

    options.forEach((option, index) => {
      if (index === options.length - 2 && option.id === "unlink-table") {
        option.isBottomLine = true;
      }
    });

    return {
      icon: "link",
      iconType: "far",
      position: this.props.dataSourceForNcol ? "right" : "bottomLeft",
      title: "Choose source to import data",
      selectedClassNameIdent: "",
      className: "assetitem-settings-dropdown",
      options,
    };
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _toggleDropdownHandler = e => {
    // e.preventDefault();
    // this.props.preventEditorToDeactivate(false);
    this.props.toggleDropdown(e, "DataSource");
    // this.props.preventEditorToDeactivate(false);
  };

  _showDataSourceLink = () => {
    const { readOnly, isLinkedToDataSource } = this.props;
    const { connected } = this.props.section;

    return !readOnly ? (
      <div className="table-add-column styling-icons table-datasource-btn">
        <Fragment>
          <div
            ref={ele => {
              this.node = ele;
            }}
            className={`table-style-items table-datasource-icon ${
              this.props.dataSourceForNcol ? "table-datasource" : ""
            } ${connected ? "table-datasource-icon-connected" : ""}`}>
            <Tooltip
              placement="top"
              overlay="Link table to data source"
              align={{
                offset: [0, 3],
              }}>
              <span
                data-test="table-datasource-span"
                className={`btn-positive ${
                  this.props.dataSourceForNcol ? "link-data-source" : ""
                }`}
                onMouseDown={e => {
                  if (this.props.coverpageThemeActionLabel !== null)
                    // To close apply formula pane if open
                    this.props.coverpageThemeAction(null);
                  this.props.toggleDropdown(e, "DataSource");
                }}
                role="button"
                tabIndex={0}>
                <i>
                  <FontAwesomeIcon icon={["far", "link"]} />{" "}
                </i>
                {this._checkTableLinkedAndSynced(
                  isLinkedToDataSource,
                  connected,
                  this.props.connected,
                ) ? (
                  <i>
                    <FontAwesomeIcon
                      icon={["fas", "check-circle"]}
                      color="#37BC72"
                      className="table-linked-synced"
                    />{" "}
                  </i>
                ) : null}

                {this.props.dataSourceForNcol && (
                  <div className="datasource-text-ncol">Link data source</div>
                )}
              </span>
            </Tooltip>
            <Dropdown
              options={this._dropdownOptionsData()}
              showDropdown={this.props.showDataSourceDropdown}
              showDropdownHandler={this._toggleDropdownHandler}
            />
          </div>
        </Fragment>
      </div>
    ) : null;
  };

  render() {
    let popupSpace = null;

    if (this.state.showTabletoGsheetConfirmation) {
      popupSpace = (
        <TableToGsheetConfirmationPopup
          updateMultipleState={this._updateMultipleState}
          saveTable={this.props.saveTable}
        />
      );
    } else if (this.state.showTableGsheetUnlink) {
      popupSpace = (
        <TableGsheetUnlinkPopup
          updateMultipleState={this._updateMultipleState}
          saveTable={this.props.saveTable}
        />
      );
    } else if (this.state.showTabletoQuoteConfirmation) {
      popupSpace = (
        <TableToQuoteConfirmationPopup
          updateMultipleState={this._updateMultipleState}
          saveTable={this.props.saveTable}
        />
      );
    } else if (this.state.showTabletoQuoteUnlink) {
      popupSpace = (
        <TableToQuoteUnlinkPopup
          updateMultipleState={this._updateMultipleState}
          saveTable={this.props.saveTable}
        />
      );
    } else if (this.state.showTableAPIUnlinkPopup) {
      popupSpace = (
        <TableAPIUnlinkPopup
          updateMultipleState={this._updateMultipleState}
          showTableAPIUnlinkPopup={this.state.showTableAPIUnlinkPopup}
          fieldsUsed={this.props.fieldsUsed}
          section={this.props.section}
        />
      );
    }
    return (
      <Fragment>
        {popupSpace}
        {this._showDataSourceLink()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta, coverpageThemeActionLabel, document, tables } =
    state.DocumentStore;
  const { showPriceBook } = state.QuotationStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  const { fields_used: fieldsUsed, id: docId } = document;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    docId,
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
    showPriceBook,
    coverpageThemeActionLabel,
    fieldsUsed,
    tables,
  };
};

const mapDispatchToProps = {
  preventEditorToDeactivate,
  toggleTabAndToolPanelData,
  coverpageThemeAction,
  tableAPILinkUnlink,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSourceBtn);
